module.exports = __webpack_public_path__ + "img/logo_piclink.b5b0f63a.png";